// @flow strict

import * as React from 'react'
import cx from 'classnames'
import { type ContentfulNode } from '@mondough/contentful'
import { getLocalisedFieldsFromNode } from '@mondough/contentful'
import { locale } from '../../../Global'

import styles from './TrustMarkerStrip.module.scss'

type TrustMarker = $ReadOnly<{|
  name: string,
  image: string,
  widgetType?: 'trustpilot',
|}>

type Props = $ReadOnly<{|
  trustMarkers?: TrustMarker[],
|}>

function Trustpilot() {
  const ref = React.useRef(null)
  const [scriptLoaded, setScriptLoaded] = React.useState(false)

  React.useEffect(() => {
    const scriptTag = document.createElement('script')
    scriptTag.src =
      '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
    scriptTag.addEventListener('load', () => setScriptLoaded(true))
    if (document.body) {
      document.body.appendChild(scriptTag)
    }
  }, [])

  React.useEffect(() => {
    if (scriptLoaded && window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [scriptLoaded])

  return (
    <div
      ref={ref}
      className={cx(styles.trustpilotWidget, styles.trustMarkerChild)}
      data-locale="en-GB"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="57da77be0000ff000594bcdb"
      data-style-height="100px"
      data-style-width="100%"
      data-theme="light"
      data-text-color="#14233C"
    >
      <a
        href="https://www.trustpilot.com/review/www.monzo.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        {' '}
        Trustpilot
      </a>
    </div>
  )
}

function TrustMarkerStrip({ trustMarkers }: Props) {
  return trustMarkers != null && trustMarkers.length > 0 ? (
    <section className={styles.trustMarkerStrip}>
      {trustMarkers.map(({ image, name, widgetType }) => {
        if (widgetType === 'trustpilot') {
          return <Trustpilot />
        }
        return (
          <div className={styles.trustMarkerChild}>
            <img key={name.replace(' ', '')} src={image} alt={name} />
          </div>
        )
      })}
    </section>
  ) : null
}

export const renderTrustMarkerStrip = (node: ContentfulNode) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}
  return <TrustMarkerStrip trustMarkers={bespokeContent.trustMarkers} />
}

export default TrustMarkerStrip
